export default __webpack_public_path__ + "static/media/decisivestrikes.55e978e4.png";